<template>
    <v-layout style="padding: 3px 10px 0;">
        <v-flex xs6 style="padding-right: 5px;">
            <statsItem title="Substances" :text="stats.substances"></statsItem>
            <statsItem title="Max RQ" :text="stats.maxRQ"></statsItem>
            <statsItem title="Median RQ" :text="formatNumber(stats.medianRQ)"></statsItem>
        </v-flex>
        <v-flex xs6 style="padding-left: 5px;">
            <statsItem title="Measurements" :text="stats.count"></statsItem>
            <statsItem title="Mean RQ" :text="formatNumber(stats.meanRQ)"></statsItem>
            <statsItem title="95th percentile RQ" :text="stats.rq95"></statsItem>
        </v-flex>
    </v-layout>
</template>

<script>
    import statsItem from './base/statsItem.vue'

    export default {
        components: {
            statsItem
        },
        props: {
            stats: {
                required: false,
                //type: TODO: add I_MEC here. 
            }
        },
        methods: {
            formatNumber(num) {
                  // Display up to 9 decimal places.
                  let numfixed = Number(num).toFixed(9);

                  let index = numfixed.length - 1;
                  while (index >= 0) {
                        if (numfixed[index] !== '0') break;
                        index--;
                  }
                  // If we stopped at a dot, then keep the dot and add a trailing zero
                  if (numfixed[index] === '.') return numfixed.substring(0, index + 1) + '0';
                  // Otherwise return the numfixed without trailing zeros
                  return numfixed.substring(0, index + 1);
                
            }
        }

    }

</script>

<style scoped>

</style>